import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '../audi-ui-components/TextField';
import Select from '../audi-ui-components/Select';
import Fieldset from '../audi-ui-components/Fieldset';

class DateField extends React.Component {

    handleChange = (field, value) => {
        var dateArray = this.props.value.split("/");
        var dateObj = {day: dateArray[0] || "", month: dateArray[1] || "", year: dateArray[2] || ""};
        dateObj[field] = value;
        var newValue = `${dateObj.day}/${dateObj.month}/${dateObj.year}`;
        this.props.onChange(newValue);
    }

    handleBlur = () => {
        if (typeof this.props.onBlur === 'function') {
            this.props.onBlur();
        }
    }

    render() {
        var dateArray = this.props.value.split("/");
        var dateObj = {day: dateArray[0], month: dateArray[1], year: dateArray[2]};
        return(
            <Fieldset
                fields={[
                    <TextField
                        type="text"
                        name={`${this.props.name}_day`}
                        value={dateObj.day || ""}
                        label="Day"
                        floatingLabel={false}
                        isValid={this.props.isValid}
                        isInvalid={this.props.isInvalid}
                        disabled={this.props.disabled}
                        onChange={(v) => {this.handleChange('day', v)}}
                        onBlur={this.handleBlur}
                        className="aui-datefield--day"
                        theme={this.props.theme} />,
                    <Select
                        name={`${this.props.name}_month`}
                        value={dateObj.month}
                        options={[
                            {label: "January", value: "01"}, {label: "February", value: "02"}, {label: "March", value: "03"}, {label: "April", value: "04"}, {label: "May", value: "05"}, {label: "June", value: "06"},
                            {label: "July", value: "07"}, {label: "August", value: "08"}, {label: "September", value: "09"}, {label: "October", value: "10"}, {label: "November", value: "11"}, {label: "December", value: "12"}
                        ]}
                        label="Month"
                        floatingLabel={false}
                        isValid={this.props.isValid}
                        isInvalid={this.props.isInvalid}
                        disabled={this.props.disabled}
                        onChange={(v) => {this.handleChange('month', v)}}
                        onBlur={this.handleBlur}
                        className="aui-datefield--month"
                        theme={this.props.theme} />,
                    <TextField
                        type="text"
                        name={`${this.props.name}_year`}
                        value={dateObj.year || ""}
                        label="Year"
                        floatingLabel={false}
                        isValid={this.props.isValid}
                        isInvalid={this.props.isInvalid}
                        disabled={this.props.disabled}
                        onChange={(v) => {this.handleChange('year', v)}}
                        onBlur={this.handleBlur}
                        className="aui-datefield--year"
                        theme={this.props.theme} />
                ]}
                title={this.props.label}
                isInvalid={this.props.isInvalid}
                invalidMessage={this.props.invalidMessage}
                className={classnames("aui-datefield", `${this.props.className}`)}
                style={this.props.style}
                theme={this.props.theme}
            />
        );
    }

}

DateField.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    invalidMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // validMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    isValid: PropTypes.bool,
    isInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string,
    theme: PropTypes.oneOf(['light']) // see styles/components/_textfield-themes.scss
};

DateField.defaultProps = {
    floatingLabel: true,
    onChange: () => {},
    style: {},
    className: ''
}

export default DateField;
